export enum CentrifugeSubscriptionType {
	app = "APP",
	fleet = "FLEET",
	osgen = "OS_GEN",
	device = "DEVICE",
	deviceCreated = "DEVICE_CREATED",
	notification = "NOTIFICATION",
	metric = "METRIC",
	updateGroup = "UPDATE_GROUP"
}
